module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tooltip":{"income":"Amount of settled and unpaid income for this month.","settled":"Amount of payments you have received, including partial payments.","unpaid":"Amount of unpaid income, including those overdue and not yet due, for this acccounting year.","overdue":"Amount of unpaid income that are past their due date. Make sure to collect your debts."}}}')
  delete Component.options._Ctor
}
